import { postJSON } from '../utils/json';

export default ({ baseURL, providers }) => ({
    return(transactionId) {
        return postJSON(`${baseURL}/old-api/pages/return/${transactionId}`, {
            language: providers.language(),
        });
    },
});
